let edgeRequestQueue: Promise<unknown> = Promise.resolve();

export const enqueueEdgeRequest = async <T>(task: () => Promise<T>): Promise<T> => {
  const run = edgeRequestQueue.then(task, task);
  edgeRequestQueue = run.catch(() => undefined);
  return run;
};
